import React from 'react';

const LOADING_CURTAIN_IMAGE_URI =
  'https://xjagwppplovcqmztcymd.supabase.co/storage/v1/object/public/media/logocortina.webp';

interface LoadingScreenProps {
  message?: string;
  submessage?: string;
}

export default function LoadingScreen({ 
  message = 'Cargando...', 
  submessage 
}: LoadingScreenProps) {
  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        background: 'linear-gradient(135deg, #160F14 0%, #24171D 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#FFFFFF',
        padding: '2rem',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          maxWidth: '400px',
        }}
      >
        <img
          src={LOADING_CURTAIN_IMAGE_URI}
          alt=""
          aria-hidden="true"
          style={{
            display: 'block',
            width: 'min(86vw, 360px)',
            height: 'min(62vh, 360px)',
            objectFit: 'contain',
            margin: '0 auto 24px',
          }}
        />

        {/* Mensaje principal */}
        <h2
          style={{
            margin: 0,
            fontSize: '1.5rem',
            fontWeight: 600,
            color: '#FFFFFF',
            marginBottom: submessage ? '8px' : 0,
            fontFamily: "'Barlow', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          }}
        >
          {message}
        </h2>

        {/* Mensaje secundario (opcional) */}
        {submessage && (
          <p
            style={{
              margin: 0,
              fontSize: '0.9rem',
              color: 'rgba(255, 255, 255, 0.7)',
              fontFamily: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            }}
          >
            {submessage}
          </p>
        )}
      </div>
    </div>
  );
}

